var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 109,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    fill: "#fff",
    fillOpacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "m84 59 2.541 15.287a3.41 3.41 0 0 0 3.172 3.172L105 80l-15.287 2.541a3.41 3.41 0 0 0-3.172 3.172L84 101l-2.541-15.287a3.41 3.41 0 0 0-3.172-3.172L63 80l15.287-2.541a3.41 3.41 0 0 0 3.172-3.172L84 59ZM44 0l4.84 29.118c.221 3.241 2.801 5.821 6.042 6.041L84 40l-29.118 4.84c-3.241.221-5.821 2.801-6.041 6.042L44 80l-4.84-29.118a6.497 6.497 0 0 0-6.042-6.041L4 40l29.118-4.84c3.241-.221 5.821-2.801 6.041-6.042L44 0ZM105 26l1.694 10.191a2.274 2.274 0 0 0 2.115 2.115L119 40l-10.191 1.694a2.274 2.274 0 0 0-2.115 2.115L105 54l-1.694-10.191a2.274 2.274 0 0 0-2.115-2.115L91 40l10.191-1.694a2.274 2.274 0 0 0 2.115-2.115L105 26Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 123,
    height: 109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyThumbnail);
export default __webpack_public_path__ + "static/media/empty-thumbnail.08e8ac44237a1a95b3c78b8c51145fbe.svg";
export { ForwardRef as ReactComponent };